import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LeadFields } from "./LeadFields";
import type { Lead } from "./types";

export function LeadForm({
  initial,
  onSubmit,
  onCancel,
  onDelete,
  busy = false,
  submitLabel = "保存盘口",
  users,
  children,
}: {
  initial: Lead;
  onSubmit: (lead: Lead) => void | Promise<void>;
  onCancel: () => void;
  onDelete?: () => void | Promise<void>;
  busy?: boolean;
  submitLabel?: string;
  users?: { id: string; username: string }[];
  children?: React.ReactNode;
}) {
  const [lead, setLead] = useState(initial);

  return (
    <form
      className="flex min-h-0 flex-1 flex-col"
      onSubmit={(event) => {
        event.preventDefault();
        void onSubmit(lead);
      }}
    >
      <div className="min-h-0 flex-1 overflow-y-auto pr-1">
        <LeadFields value={lead} onChange={setLead} users={users} />
        {children}
      </div>
      <div className="mt-6 flex items-center justify-between gap-2 border-t pt-4">
        <div>
          {onDelete && (
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="size-10 text-muted-foreground hover:text-destructive"
              aria-label="删除盘口"
              title="删除盘口"
              disabled={busy}
              onClick={() => {
                if (
                  window.confirm(
                    "确定删除这条盘口？它将从工作区隐藏，管理员仍可恢复。",
                  )
                )
                  void onDelete();
              }}
            >
              <Trash2 />
            </Button>
          )}
        </div>
        <div className="flex gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            disabled={busy}
          >
            取消
          </Button>
          <Button
            type="submit"
            disabled={busy || !lead.model.trim() || !lead.valid_until}
          >
            {busy ? "保存中…" : submitLabel}
          </Button>
        </div>
      </div>
    </form>
  );
}
